import { useCallback } from 'react';
import { UseFormHandleSubmit, UseFormTrigger } from 'react-hook-form';
import { FlowFormData } from '../validations/flowForm';
import { CreateFlowResponse } from '@/lib/api/email-flows/types';

interface UseAddFlowFormActionsProps {
    currentStep: number;
    isFirstStep: boolean;
    isLastStep: boolean;
    flowName: string;
    goToNextStep: () => void;
    goToPreviousStep: () => void;
    setSubmittedName: (name: string) => void;
    handleSubmit: UseFormHandleSubmit<FlowFormData>;
    trigger: UseFormTrigger<FlowFormData>;
    submitFlow: (data: FlowFormData) => Promise<CreateFlowResponse>;
}

export const useAddFlowFormActions = ({
    currentStep,
    isFirstStep,
    isLastStep,
    flowName,
    goToNextStep,
    goToPreviousStep,
    setSubmittedName,
    handleSubmit,
    trigger,
    submitFlow,
}: UseAddFlowFormActionsProps) => {
    const handleBackOrCancel = useCallback(() => {
        if (isFirstStep) {
            window.history.back();
            return;
        }
        goToPreviousStep();
    }, [isFirstStep, goToPreviousStep]);

    const handleNextOrCreate = useCallback(async () => {
        const isValid = await trigger();

        if (!isValid) {
            return;
        }

        if (isLastStep) {
            handleSubmit(submitFlow)();
            return;
        }

        if (currentStep === 1) {
            setSubmittedName(flowName || 'New Email Flow');
        }
        goToNextStep();
    }, [isLastStep, currentStep, flowName, handleSubmit, submitFlow, trigger, setSubmittedName, goToNextStep]);

    return {
        handleBackOrCancel,
        handleNextOrCreate,
    };
};
